import { render, staticRenderFns } from "./pay-info-detail.vue?vue&type=template&id=d488d00c&scoped=true"
import script from "./pay-info-detail.vue?vue&type=script&lang=js"
export * from "./pay-info-detail.vue?vue&type=script&lang=js"
import style0 from "./pay-info-detail.vue?vue&type=style&index=0&id=d488d00c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d488d00c",
  null
  
)

export default component.exports